import React from 'react-bootstrap';

import { Row, Col, Button, ButtonGroup, Table, Card } from 'react-bootstrap'

import TrafficLight from '../TrafficLight.js';
import SewageSummaryIconComponent from '../SewageSummaryIconComponent.js';
import SewageOperatorMapFooter from '../SewageOperatorMapFooter.js';
import StationLinker from '../StationLinker.js';

import { formatTimestamp } from '../../lib/formatHelpers.js';

import { sendNavigateToSearchSewageReport } from '../GoogleAnalytics.js';

import CentralLink from '../CentralLink.js'
import NearBySewagePlace from '../NearBySewagePlace.js'

import CommonHeaders from '..//helmet-headers/CommonHeaders.js';

import { ArrowUpLeftCircleFill } from 'react-bootstrap-icons';


const statusToDescription = {
	'START': 'Discharging',
	'OFFLINE': "Offline",
	'STOP': "Not Discharging"
}

const SewageTable = ({ liveSewage }) => {
    return (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                	<th>&nbsp;</th>
                    <th>Station Name</th>
                    <th>Discharges To</th>
                    <th>Status</th>
                    <th>Since</th>
                    <th>Last Update</th>
                </tr>
            </thead>
            <tbody>
                {liveSewage.map((entry) => (
                    <tr key={entry.metricId}>
                    	<td>
                    		<StationLinker stationName={entry.stationName} stationId={entry.stationId} metricId={entry.metricId}>
                    			<Button variant="dark" size="sm">View</Button>
                    		</StationLinker>
                    	</td>
                        <td>{entry.stationName}</td>
                        <td>{entry.receivingWaterCourse}</td>
                        <td>{statusToDescription[entry.status] ? statusToDescription[entry.status] : entry.status}</td>
                        <td>{formatTimestamp(entry.statusStart)}</td>
                        <td>{formatTimestamp(entry.lastUpdated)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

function SewagePlaceLive({ place }) {

	let sewageSummary = {
		noResult: true,
		discharging: [],
		offline: [],
		notDischarging: [],
		lightStatus: 'OFFLINE',
		operators: {}
	}
	if(place && place.liveSewage && Array.isArray(place.liveSewage)) {
		sewageSummary.noResult = false;
		place.liveSewage.map(function(metric) {
			sewageSummary.operators[metric.operator] = true;
			switch(metric.status) {
				case 'START':
					sewageSummary.discharging.push(metric);
					break;
				case 'OFFLINE':
					sewageSummary.offline.push(metric);
					break;
				case 'STOP':
					sewageSummary.notDischarging.push(metric);
					break;
			}
		});

		if(sewageSummary.discharging.length) {
			sewageSummary.lightStatus = 'START';
		} else if(sewageSummary.offline.length) {
			sewageSummary.lightStatus = 'OFFLINE';
		} else {
			sewageSummary.lightStatus = 'STOP';
		}
	}


	return <div>
		<CommonHeaders
			title={"Sewage Report - " + place.placeName}
			description={"Live sewage discharge data for " + place.placeName}
		/>
		<Row>
			<Col xs={12} className="header-bold text-white bg-dark hX-scale12em">{place.placeName} - Live Sewage Discharge Report</Col>
			<Col xs={2} md={3} className="mt-2 mb-2">
				<center>
					{!sewageSummary.noResult ? <TrafficLight status={sewageSummary.lightStatus} /> : <span>Status not known at this location</span>}
					{!sewageSummary.noResult ? <SewageSummaryIconComponent
												totalSpills={sewageSummary.discharging.length}
												totalOffline={sewageSummary.offline.length}
											/> : null}
				</center>
			</Col>
			<Col xs={10} md={8} className="mt-2 mb-2">
				{place && place.liveSewage && sewageSummary.discharging.length ? <Card className="mb-2">
					<Card.Header className="bg-dark text-white header-bold">Discharging Station List</Card.Header>
					<Card.Body>
						<SewageTable liveSewage={sewageSummary.discharging} />
					</Card.Body>
				</Card> : null}
				{place && place.liveSewage && sewageSummary.offline.length ? <Card className="mb-2">
					<Card.Header className="bg-dark text-white header-bold">Offline Station List</Card.Header>
					<Card.Body>
						<SewageTable liveSewage={sewageSummary.offline} />
					</Card.Body>
				</Card> : null}
				<Row>
					<Col xs={6} lg={7}></Col>
					<Col xs={6} lg={5}>
						{Object.keys(sewageSummary.operators).length ? <span>
							<ButtonGroup>
								{Object.keys(sewageSummary.operators).map(function(waterOperatorName) {
									return <CentralLink to={"/data-explorer/search-sewage-operator/" + waterOperatorName}>
										<Button variant="dark" size="sm" style={{marginLeft: "2px", marginRight: "2px"}}><ArrowUpLeftCircleFill /> View all {waterOperatorName}</Button>
									</CentralLink>
								})}
							</ButtonGroup>
						</span> : null}
					</Col>
					<Col xs={12}><hr /></Col>
				</Row>
				{place && place.liveSewage && sewageSummary.notDischarging.length ? <Card className="mb-2">
					<Card.Header className="bg-dark text-white header-bold">Non-Discharging Station List</Card.Header>
					<Card.Body>
						<SewageTable liveSewage={sewageSummary.notDischarging} />
					</Card.Body>
				</Card> : null}
				{place && place.liveSewage && Array.isArray(place.liveSewage) ? <span style={{fontWeight: "0.6em"}}><i><b>Note</b>: stations may have multiple outlets, which is why they may appear more than once.</i></span> : null}
			</Col>
			<Col xs={12} md={1}></Col>
		</Row>
		<Row>
			{place.nearByPlaces ? [
						<Col xs={12} key="placeHeader" className="bg-secondary text-white header-bold">View Summaries Nearby</Col>,
						<Col xs={12} key="placeList" className="mt-2 mb-2">
							{Object.keys(place.nearByPlaces).map(function(nearByPlaceKey) {
								const nearByPlace = place.nearByPlaces[nearByPlaceKey];
								return <NearBySewagePlace place={nearByPlace} />
							})}
							<CentralLink to={"/data-explorer/search-sewage-report"} onClick={function() {
								sendNavigateToSearchSewageReport();
							}}>
								<Button variant="secondary" size="sm"><b><i>Somewhere else?</i></b></Button>
							</CentralLink>
							{Object.keys(sewageSummary.operators).length ? <br /> : null}
							{Object.keys(sewageSummary.operators).map(function(waterOperatorName) {
								return <CentralLink to={"/data-explorer/search-sewage-operator/" + waterOperatorName}>
									<Button variant="dark" size="sm" className="mt-1">{waterOperatorName}</Button>
								</CentralLink>;
							})}
						</Col>
					] : null}
			<Col xs={12}><SewageOperatorMapFooter showUnmatchedExplaination={false} /></Col>
		</Row>
	</div>
}

export default SewagePlaceLive;